import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { PropertyService } from '../../property';
import { AlertService } from '../../../_services';
import { ApiResponse } from '../../../_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { BedroomService } from './bedroom.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BedroomFormComponent } from './components/bedroom-form/bedroom-form.component';

@Component({
    selector: 'app-bedroom',
    templateUrl: './bedroom.component.html',
    styleUrls: ['./bedroom.component.css'],
    providers: [
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    standalone: false
})



export class BedroomComponent implements OnInit, OnChanges
{

	constructor(private router: Router,
		private activatedRoute: ActivatedRoute,
		private bedroomService: BedroomService,
		private featureService: FeatureService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
	)
	{
	}



	// data
	@Input() shortTermRentalId: number;
	@Input() featuresList = [];
	bedrooms: any[] = [];
	apiResponse: ApiResponse;
	formLoading: any;
	formAlert: String;
	totalSleepingCapacity: number = 0;

	ngOnInit()
	{
		this.findBedroomsByShortTermRentalId();
	}

	ngOnChanges(changes: SimpleChanges)
	{

		// update the data if the shortTermRentalId input changes

		// find what property changed
		for (let propName in changes)
		{
			if (propName === 'shortTermRentalId')
			{
				let change = changes[propName];
				this.findBedroomsByShortTermRentalId();
			} else if (propName === 'featuresList')
			{
				// do nothing
			}
		}
	}

	findBedroomsByShortTermRentalId()
	{
		try
		{
			// stop here if form is invalid
			if (!this.shortTermRentalId)
			{
				return;
			}

			this.formLoading = true;

			this.bedroomService.findBedroomsByShortTermRentalId(this.shortTermRentalId)
				.subscribe(
					res =>
					{
						// console.log('bedroom-findBedroomsByShortTermRentalId SUCCESS: ' + JSON.stringify(res));
						this.apiResponse = res;
						this.bedrooms = res.data.bedrooms;
						this.calculateTotalSleepingCapacity();

					},
					err =>
					{
						console.log('bedroom-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}


	openFormAdd()
	{
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data
		dialogConfig.data = {
			shortTermRentalId: this.shortTermRentalId,
			title: 'Add Bedroom'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(BedroomFormComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(

			data =>
			{
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addBedroom(data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	/**
	 *
	 * Dialog Form Callbacks
	 * To edit the list show add/edit/delete in real time from the popup form
	 *
	 */

	addBedroom(event)
	{
		console.log('Adding Bedroom: ' + event);
		// if we don't have a bedrooms array yet...
		if (!this.bedrooms)
		{
			this.bedrooms = [];
		}
		this.bedrooms.push(event);
		this.formAlert = 'Bedroom #' + event.bedroomId + ' added.';
		this.calculateTotalSleepingCapacity();
	}


	updateBedroom(event)
	{
		console.log('Updating Bedroom: ' + JSON.stringify(event));
		let itemIndex = this.bedrooms.findIndex(item => item.bedroomId === event.bedroomId);
		this.bedrooms[itemIndex] = event;
		this.calculateTotalSleepingCapacity();
	}


	deleteBedroom(event)
	{
		console.log('Removing Bedroom: ' + event);
		this.bedrooms = this.bedrooms.filter(item => item !== event);
		this.calculateTotalSleepingCapacity();
	}

	calculateTotalSleepingCapacity(): void
	{
		if (!this.bedrooms || this.bedrooms.length === 0)
		{
			this.totalSleepingCapacity = 0;
			return;
		}
		this.totalSleepingCapacity = this.bedrooms.reduce((total, bedroom) => {
			return total + (bedroom.sleepsMax ? Number(bedroom.sleepsMax) : 0);
		}, 0);
	}
}
